import { useProductStoreActions } from '@/modules/product/stores/product.store'
import { removeItemFromStorage } from '@/modules/shared/utils/storage-helper'

import { useOrderFormComponentStoreActions } from '../stores/order-form-component.store'
import { useOrderFormStoreActions } from '../stores/order-form.store'

export const useOrderFormClearData = () => {
  const {
    setEntityTypeSelected,
    setIsCalculationOrder,
    setJsonOrderForm,
    setOperationType,
    setParamsLayoutOrderForm,
    setParamsOrderForm,
    setOrderSelected,
  } = useOrderFormStoreActions()

  const {
    setCustomers,
    setEntityType,
    setFilterToCreatePaginationOfProduct,
    setIsOpenOrderFormModalEntity,
    setTransports,
  } = useOrderFormComponentStoreActions

  const {
    setCurrentPagination,
    setIsActiveInfinityScroll,
    setProductPaginate,
    setProducts,
  } = useProductStoreActions

  const clearAllDataOfOrder = async () => {
    setEntityTypeSelected('')
    setIsCalculationOrder(false)
    setJsonOrderForm(undefined)
    setOperationType('add')
    setParamsLayoutOrderForm(undefined)
    setParamsOrderForm(undefined)

    setCustomers(undefined)
    setEntityType('client')
    setFilterToCreatePaginationOfProduct(undefined)
    setIsOpenOrderFormModalEntity(false)
    setTransports(undefined)

    setCurrentPagination(0)
    setIsActiveInfinityScroll(false)
    setProductPaginate(undefined)
    setProducts(undefined)
    setOrderSelected(undefined)

    removeItemFromStorage('order-form')
  }

  return {
    clearAllDataOfOrder,
  }
}
